<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-04-15 19:30:04
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-20 10:59:24
 * @FilePath: /wemeet-admin-new/src/views/enterPriseConfig/components/editOrder.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-drawer v-model="innerDrawer" :append-to-body="true" :before-close="handleCloseInner" :title="innerDrawertitle">
      <el-form v-if="innerDrawertitle == '修改有效期'" ref="formRef" :model="dateForm" :rules="rules">
        <el-form-item label="开始时间" prop="startDate">
          <el-input v-model="dateForm.startDate" disabled />
        </el-form-item>
        <el-form-item label="结束时间" prop="expireTime">
          <el-date-picker v-model="dateForm.expireTime" placeholder="选择结束时间" type="date" />
        </el-form-item>
        <el-form-item label="修改原因" prop="reason">
          <el-input v-model="dateForm.reason" placeholder="请填写原因" />
        </el-form-item>
      </el-form>

      <el-table v-else border :data="changeList">
        <el-table-column label="修改时间" prop="company">
          <template #default="{ row }">
            {{ handleDate(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="修改后的有效期" prop="company">
          <template #default="{ row }">{{ row.oldData }} 至 {{ row.newData }}</template>
        </el-table-column>
        <el-table-column label="修改原因" prop="reason" />
      </el-table>

      <div v-if="innerDrawertitle == '修改有效期'" class="el-drawer__footer">
        <el-button type="primary" @click="upDateExpire">提交</el-button>
        <el-button @click="handleCloseInner">取消</el-button>
      </div>
    </el-drawer>

    <div class="containerForm">
      <el-descriptions border :column="1" direction="horizontal" :size="desSize" title="订单基础信息">
        <el-descriptions-item label="订单编号">
          <span>{{ form.orderNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="订单类型">
          <span>{{ form.orderType == 'MASTER_PRODUCTS' ? '主产品' : '增值产品' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="订单内容">
          <span>{{ form.goodsName ? form.goodsName : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="下单方式">
          <span>{{ handlePayType() }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="订单价格">
          <span>{{ form.price ? form.price : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="订单有效期">
          <span>{{ form.effectiveDay }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="订单提交时间">
          <span>{{ form.createTime ? form.createTime : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-if="form.status == 'PAY_OVER'" label="订单生效时间">
          <span>{{ form.effectiveTime ? form.effectiveTime : '/' }}</span>
        </el-descriptions-item>

        <el-descriptions-item v-if="form.status == 'PAY_NOT_PASS'" label="订单驳回时间">
          <span>{{ form.payReasonTime ? form.payReasonTime : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-if="form.status != 'PAY_NOT_PASS' && form.status != 'CLOSED'" label="订单到期时间">
          <span>{{ form.expireTime ? form.expireTime : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item v-else label="订单取消时间">
          <span>{{ form.cancelTime ? form.cancelTime : '/' }}</span>
        </el-descriptions-item>

        <!-- <el-descriptions-item label="交易流水号" v-if="form.payType == 'WECHAT_PAY'">
          <span>{{ form.outOrderNo }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="交易凭证" v-if="form.payType != 'WECHAT_PAY'">
          <el-image v-for="(item, index) in form.attachUrls" style="width: 100px; height: 100px" :src="item" :zoom-rate="1.2" :initial-index="4" fit="cover" :preview-src-list="[item]" />
        </el-descriptions-item> -->
        <!-- <el-descriptions-item label="提交时间">
          <span>{{ handleDate(form.orderTime) }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">
          <span>{{ form.payTime ? handleDate(form.payTime) : '暂无' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="有效期至">
          <span>
            {{
              form.payType == 'NON_PROFIT_ORG'
                ? '终身'
                : handleDate(form.expireTime, '{y}-{m}-{d}')
            }}
          </span>
          <div>
            <el-button type="success" @click="handleOpenInner('edit')" plain>
              修改有效期
            </el-button>
            <el-button type="success" @click="handleOpenInner('see')" plain>
              查看修改记录
            </el-button>
          </div>
        </el-descriptions-item> -->
        <div v-if="formStatus == 'SEE' || formStatus == 'MANAGAR'">
          <el-descriptions-item label="支付状态">
            <span>
              {{
                form.status == 'PAY_WAIT'
                  ? '待支付'
                  : form.status == 'PAY_OVER'
                  ? '已支付'
                  : form.status == 'PAY_CONFIRMED'
                  ? '支付待确认'
                  : form.status == 'PAY_NOT_PASS'
                  ? '支付被驳回'
                  : '支付取消'
              }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item v-if="form.status == 'PAY_NOT_PASS'" label="支付不通过原因">
            <span>
              {{ form.payReason }}
            </span>
          </el-descriptions-item>
        </div>

        <el-descriptions-item v-if="formStatus == 'PAY'" label="支付状态">
          <el-select v-model="payStatus.payStatus" class="m-2" placeholder="请选择支付状态">
            <el-option v-for="item in payStatusOption" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>

          <el-input
            v-if="payStatus.payStatus == 'PAY_NOT_PASS'"
            v-model="payStatus.reason"
            placeholder="不通过原因"
            style="margin-top: 5px"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        v-if="form.orderMethod != 'DONATION' && form.status != 'PAY_WAIT' && form.status != 'CLOSED'"
        border
        :column="1"
        direction="horizontal"
        :size="desSize"
        style="margin-top: 10px"
        title="支付信息"
      >
        <el-descriptions-item label="订单支付时间">
          <span>{{ form.payTime ? form.payTime : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">
          <span>
            {{
              form.payType == 'WECHAT_PAY'
                ? '微信支付'
                : form.payType == 'CORPORATE_TRANSFER'
                ? '对公转账'
                : '非盈利机构'
            }}
          </span>
        </el-descriptions-item>
        <el-descriptions-item v-if="form.payType == 'WECHAT_PAY'" label="微信交易流水号">
          <span>{{ form.outOrderNo }}</span>
        </el-descriptions-item>

        <el-descriptions-item v-if="form.payType == 'CORPORATE_TRANSFER'" label="交易凭证">
          <el-image
            v-for="(item, index) in form.attachUrls"
            fit="cover"
            :initial-index="4"
            :preview-src-list="form.attachUrls"
            :src="item"
            style="width: 100px; height: 100px"
            :zoom-rate="1.2"
          />
        </el-descriptions-item>

        <el-descriptions-item v-if="form.payType == 'NON_PROFIT_ORG'" label="证明材料">
          <el-image
            v-for="(item, index) in form.attachUrls"
            fit="cover"
            :initial-index="4"
            :preview-src-list="form.attachUrls"
            :src="item"
            style="width: 100px; height: 100px"
            :zoom-rate="1.2"
          />
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        border
        :column="1"
        direction="horizontal"
        :size="desSize"
        style="margin-top: 10px"
        title="下单人信息"
      >
        <el-descriptions-item label="下单人姓名">
          <span>{{ form.payUserName ? form.payUserName : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="下单人手机号">
          <span>{{ form.payUserPhone ? form.payUserPhone : '/' }}</span>
        </el-descriptions-item>
      </el-descriptions>

      <el-descriptions
        border
        :column="1"
        direction="horizontal"
        :size="desSize"
        style="margin-top: 10px"
        title="下单机构信息"
      >
        <el-descriptions-item label="下单机构">
          <span>{{ form.enterpriseName ? form.enterpriseName : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="机构负责人姓名">
          <span>{{ form.enterpriseUserName ? form.enterpriseUserName : '/' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="机构负责人手机号">
          <span>{{ form.enterpriseUserPhone ? form.enterpriseUserPhone : '/' }}</span>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div v-if="formStatus == 'PAY'" class="el-drawer__footer">
      <el-button type="primary" @click="save">提交</el-button>
      <el-button @click="handleClose">取消</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, toRefs } from 'vue'
  import {
    auditEnterPrise,
    updatePayStatus,
    updateExpireTime,
    getOrderExpireTimeHistory,
    queryOrderEnterpriseDetail,
  } from '@/api/enterPriseApi'
  import { parseTime } from '@/utils/index'

  export default defineComponent({
    name: 'PageEdit',
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()

      const state = reactive({
        dialogFormVisible: false,
        innerDrawer: false,
        formRef: null,
        direction: 'rtl',
        size: '40%',
        title: '',
        form: {},
        formStatus: '',
        desSize: 'large',
        payStatusOption: [
          {
            label: '通过',
            value: 'PAY_OVER',
            value1: 'AUDIT_APPROVED',
          },
          {
            label: '不通过',
            value: 'PAY_NOT_PASS',
            value1: 'REJECTED',
          },
        ],
        payStatus: {
          reason: '',
        },
        auditStatus: {
          reason: '',
        },
        innerDrawertitle: '修改有效期',
        dateForm: {},
        changeList: [],
        rules: {
          reason: [
            {
              required: true,
              message: '请填写原因',
              trigger: 'blur',
            },
          ],
        },
      })

      const showEdit = async (row) => {
        state.formStatus = row.formStatus
        state.title = row.formStatus == 'SEE' ? '查看详情' : '审核'
        let { data } = await queryOrderEnterpriseDetail(row.orderNo, { eventKey: row.eventKey })
        console.log(data)
        state.form = data
        state.dialogFormVisible = true
      }

      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
        state.payStatus = {
          reason: '',
          payStatus: '',
        }
      }

      const save = async () => {
        if (state.formStatus == 'PAY') {
          console.log(state.payStatus.payStatus)
          if (state.payStatus.payStatus == 'undefined' || state.payStatus.payStatus == undefined) {
            proxy.$baseMessage(`请选择支付状态`, 'error', 'vab-hey-message-error')
            return false
          }
          if (state.payStatus.payStatus == 'PAY_NOT_PASS' && state.payStatus.reason == '') {
            proxy.$baseMessage(`原因不能为空`, 'error', 'vab-hey-message-error')
            return false
          }
          state.payStatus.orderNo = state.form.orderNo
          state.payStatus.payType = state.form.payType
          let data = await updatePayStatus(state.payStatus)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
          emit('fetch-data')
          handleClose()
        }
      }

      const handleDate = (date, format = '{y}-{m}-{d} {h}:{i}:{s}') => {
        return parseTime(date, format)
      }

      const handleCloseInner = () => {
        state.innerDrawer = false
      }

      const handleOpenInner = async (type) => {
        if (type == 'edit') {
          state.dateForm.startDate = parseTime(state.form.orderTime, '{y}-{m}-{d}')
          state.dateForm.expireTime = parseTime(state.form.expireTime, '{y}-{m}-{d}')
          state.innerDrawertitle = '修改有效期'
          state.innerDrawer = true
        } else {
          let params = {
            orderNo: state.form.orderNo,
            pageNum: 1,
            pageSize: 9999,
          }
          const { data } = await getOrderExpireTimeHistory(params)
          console.log(data)
          state.changeList = data.list
          state.innerDrawertitle = '修改记录'
          state.innerDrawer = true
        }
      }

      const upDateExpire = async () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            state.dateForm.orderNo = state.form.orderNo
            state.dateForm.expireTime = parseTime(state.dateForm.expireTime, '{y}-{m}-{d} {h}:{i}:{s}')
            const { data } = await updateExpireTime(state.dateForm)
            state.innerDrawer = false
            state.form.expireTime = state.dateForm.expireTime
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            emit('fetch-data')
          }
        })
      }

      const handlePayType = () => {
        let payTypeOption = [
          {
            label: '初次开通',
            value: 'FIRST_ORDER',
          },
          {
            label: '续费服务',
            value: 'RENEWAL',
          },

          {
            label: '免费赠送',
            value: 'DONATION',
          },
        ]
        return payTypeOption.filter((item) => item.value == state.form.orderMethod)[0].label
      }

      return {
        ...toRefs(state),
        showEdit,
        save,
        handleDate,
        handleClose,
        handleCloseInner,
        handleOpenInner,
        upDateExpire,
        handlePayType,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }
  .containerForm {
    height: 85vh;
    overflow: auto;
    padding-bottom: 100px;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .el-drawer__footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    z-index: $base-z-index + 1;
    padding: math.div($base-padding, 2);
    background: var(--el-color-white);
    border-top: 1px solid $base-border-color;
  }
</style>
